import React, { useState, useEffect, ReactNode, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Row,
  Col,
  Avatar,
  Typography,
  Divider,
  Dropdown,
  Menu,
  Button,
  Spin,
  Popover,
  Carousel,
  Pagination,
  Modal,
} from 'antd';
import { FaStar, FaRegClock, FaMapMarkerAlt, FaSlidersH } from 'react-icons/fa';
import { MdArrowDropDown } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import classnames from 'classnames';
import Geocode from 'react-geocode';
import DayPicker, { DayModifiers } from 'react-day-picker';
import _ from 'lodash';
import { GOOGLE_API_KEY } from '../../../constants/googleapi';
import {
  getMealState,
  sortedMealsByDistance,
} from '../../../store/meals/selector';
import { Meal, MealWithDistance } from '../../../store/meals/types';
import { Search } from '../../desktop/components/Search';
import { Link, useHistory } from 'react-router-dom';
import { History } from 'history';
import { PlaceOrderHandler } from '../../orders/PlaceOrder';
import { DesktopOrderButton } from './OrderButton';
import { getUserState } from '../../../store/user/selector';
// import { FilterForm } from './Filter';

import MealSearchImage from '../../../assets/images/png/swap/search_icon.png';
import { setFilterData } from '../../../store/user/actions';
import { getFilterData } from './MealCarousel';
import { GiCancel } from 'react-icons/gi';
import moment from 'moment';
import { colors } from '../../../constants/colors';
import { getAdminState } from '../../../store/admin/selector';
import { AccountTypeContext } from '../Dashboard';
import { AuthModalContent } from '../../layout/Header';

const BREAKFAST_TIME = '7 AM – 11 AM';
const LUNCH_TIME = '11 AM – 17 PM';
const DINNER_TIME = '17 PM – 23 PM';

Geocode.setApiKey(GOOGLE_API_KEY);

export interface MealCardsParams {
  meal: MealWithDistance;
}
export interface CoverImageProps {
  meal: Meal;
  time: string;
}

export interface DayRenderProps {
  date: Date;
  schedule: any;
}

export interface CenterProps {
  lat?: number;
  lng?: number;
}
export interface PositionProps {
  latitude: any;
  longitude: any;
}

export const getScheduleTime = (scheduleTime: string | undefined) => {
  let time = '';
  switch (scheduleTime) {
    case 'a.m':
      time = BREAKFAST_TIME;
      break;
    case 'p.m':
      time = LUNCH_TIME;
      break;
    case 'Evening':
      time = DINNER_TIME;
      break;
    default:
      time = '';
  }
  return time;
};

export const getScheduleDate = (scheduleDate: any | undefined) => {
  return scheduleDate.filter(
    (item: { date: { seconds: any } }) => item.date.seconds
  );
};

export const CoverImageDetails: React.FC<CoverImageProps> = ({
  meal,
  time,
}) => {
  const history = useHistory();
  const { user } = useSelector(getUserState);
  const { accountType } = user;
  const isGuest = accountType === 'i seek';
  const newitems = {
    ...meal,
    time: time,
    isGuest,
  };
  const navigate = () => {
    history.push({
      pathname: '/offerdetails',
      state: newitems,
    });
  };
  return (
    <div
      className="meal-cover-image"
      style={{
        backgroundImage: `url(${meal.image})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        maxHeight: '200px',
      }}
      onClick={navigate}
    >
      <div className="meal-image-overlay" />
      {/* <div className="meal-image-bottom-items">
        <span>{`Kč ${meal.price}`}</span>
      </div> */}
    </div>
  );
};

export const toRad = (val: any) => {
  return (val * Math.PI) / 180;
};

export const calcCrow = (lat1: any, lon1: any, lat2: any, lon2: any) => {
  const R = 6371.071; // km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const lats1 = toRad(lat1);
  const lats2 = toRad(lat2);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lats1) * Math.cos(lats2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d;
};

export const PopOverContent: React.FC<DayRenderProps> = ({
  date,
  schedule,
}) => {
  const [dateSchedTime, setDateSchedTime] = useState([]);

  const validateTime = () => {
    schedule.forEach((sched: { date: { seconds: number }; time: any }) => {
      if (
        moment(new Date(sched.date.seconds * 1000)).format('MM/DD/YYYY') ===
        moment(date).format('MM/DD/YYYY')
      ) {
        // console.log(sched.time);
        setDateSchedTime(sched.time);
      }
    });
  };
  useEffect(validateTime, []);
  return (
    <div className="popover-container">
      <div>
        <span className="popover-date">
          {dateSchedTime && dateSchedTime.length === 0
            ? i18n.t('NO_TIME_SCHEDULE')
            : i18n.t('TIME_SCHEDULE')}
        </span>
        {dateSchedTime &&
          dateSchedTime.map((item: any, i: string | number | undefined) => {
            const btnClass = classnames({
              'popover-items': true,
              'popover-items-active': true,
            });
            return (
              <div key={i} className={btnClass}>
                <span>
                  {item === 'a.m'
                    ? `${i18n.t(item)} ${BREAKFAST_TIME}`
                    : item === 'p.m'
                    ? `${i18n.t(item)} ${LUNCH_TIME}`
                    : `${i18n.t(item)} ${DINNER_TIME}`}
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export const MealItems: React.FC<MealCardsParams> = ({ meal }) => {
  const { cookDetails, stableoffer } = meal;
  const { schedule } = meal;
  const getFirstSchedule = _.head(schedule);
  const getFirstScheduleTime = _.head(getFirstSchedule?.time);
  // const [cooksLocation, setCooksLocation] = useState<CenterProps>();
  const time = getScheduleTime(getFirstScheduleTime);
  const history: History = useHistory();
  const [visible, setVisibility] = useState(false);
  const [selectedDays, setSelectedDays] = useState<(Date | undefined)[]>();
  // const [checkDate, setCheckDate] = useState<Date>(new Date());
  const { ratings, user } = useSelector(getUserState);
  const { forWho } = useContext(AccountTypeContext);

  const handleCancelPress = () => {
    Modal.destroyAll();
  };

  const handleLinkClick = (link: string) => (): void => {
    history.push(link);

    setTimeout(() => {
      Modal.destroyAll();
    }, 500);
  };

  const restrictionModalConfig = {
    icon: null,
    false: true,
    maskClosable: true,
    className: 'modal-content-container modal-content-description',
    okButtonProps: { style: { display: 'none' } },
    content: (
      <AuthModalContent
        onCreateAccountPress={handleLinkClick(
          `/authentication/registration/${forWho}`
        )}
        onLoginAccountPress={handleLinkClick(
          `/authentication/login/email/${forWho}`
        )}
        onPressCancel={handleCancelPress}
      />
    ),
  };

  const handleButtonClick = () => {
    if (user.userid) {
      PlaceOrderHandler({ meal, history });
      return;
    }
    Modal.info(restrictionModalConfig);
  };
  const handleVisibleChange = () => {
    setVisibility(!visible);
  };

  const validateDate = () => {
    const dates =
      getScheduleDate(schedule) &&
      getScheduleDate(schedule).map(
        (s: { time: string | any[]; date: any }) => {
          if (s.time && s.time.length) {
            // setCheckDate(new Date(s.date.seconds * 1000));
            return new Date(s.date.seconds * 1000);
          }
          // setCheckDate(new Date(s.date.seconds * 1000));
          return new Date(s.date.seconds * 1000); // remove if error
        }
      );
    setSelectedDays(dates);
  };
  const renderDay = (date: Date, modifiers: DayModifiers): ReactNode => {
    const customDate = new Date(date).getDate();
    return (
      <Popover
        key={customDate}
        content={<PopOverContent date={date} schedule={schedule} />}
        trigger="click"
      >
        <div>{customDate}</div>
      </Popover>
    );
  };

  const arrayHeaderMonths = [
    i18n.t('January'),
    i18n.t('February'),
    i18n.t('March'),
    i18n.t('April'),
    i18n.t('May'),
    i18n.t('June'),
    i18n.t('July'),
    i18n.t('August'),
    i18n.t('September'),
    i18n.t('October'),
    i18n.t('November'),
    i18n.t('December'),
  ];
  const content = (
    <div
      style={{
        padding: '20px',
        height: '380px',
        width: '330px',
      }}
    >
      {selectedDays && selectedDays.length > 0 ? (
        <DayPicker
          selectedDays={selectedDays}
          className="date-picker-container"
          months={arrayHeaderMonths}
          renderDay={renderDay}
        />
      ) : (
        <div className="popover-container">
          {stableoffer?.isChecked && (
            <div>
              <span style={{ color: colors.black }}>{`${i18n.t(
                'TIME_SCHEDULE'
              )}`}</span>
              {stableoffer.time &&
                stableoffer.time.map((t, i) => {
                  const btnClass = classnames({
                    'popover-items': true,
                    'popover-items-active': true,
                  });
                  return (
                    <div key={i} className={btnClass}>
                      <span style={{ marginLeft: '10px' }}>
                        {t === 'a.m'
                          ? `${i18n.t(t)} - 7 AM – 11 AM`
                          : t === 'p.m'
                          ? `${i18n.t(t)} - 11 AM – 17 PM`
                          : `${i18n.t(t)} - 17 AM – 23 PM`}
                      </span>
                    </div>
                  );
                })}
            </div>
          )}
          {/* <Row justify="center">
          <span>{i18n.t('NO_DATES')}</span>
        </Row> */}
        </div>
      )}
    </div>
  );
  useEffect(validateDate, [schedule]);
  const checklength = ratings.filter(item => item.user === cookDetails?.id);
  const rate = ratings
    .filter(v => v.user === cookDetails?.id)
    .reduce((a, b) => a + b.rate / checklength.length, 0);
  return (
    <Col className="meal-cards">
      <CoverImageDetails meal={meal} time={time} />
      <div className="meal-body">
        <div className="meal-cook">
          <Link
            to={{
              pathname: '/userprofile/profile',
              state: cookDetails,
            }}
          >
            <Avatar src={cookDetails?.image} />
            <Typography.Text className="cooks-name">
              {cookDetails?.firstName}
            </Typography.Text>
          </Link>
          <span className="meal-profile-rating">
            <FaStar color="#F7C82E" size={14} style={{ marginRight: 5 }} />
            {rate !== 0 ? rate : 'No Ratings'}
          </span>
        </div>
        <Divider />
        <div className="meal-time-location">
          <Col className="meal-location">
            <FaMapMarkerAlt color="#A8A8A8" />
            <span>
              {(meal.distance / 1000).toFixed(2).toString() === NaN.toString()
                ? `${meal.cookDetails?.address &&
                    meal.cookDetails?.address.city}`
                : `${(meal.distance / 1000).toFixed(2)} km`}
            </span>
          </Col>
          <Col className="float-right">
            {time !== '' ? <FaRegClock size={15} color="#939393" /> : null}
            {time !== '' ? <span>{time}</span> : i18n.t('CONSTANT_OFFER')}
          </Col>
        </div>
        <Popover
          content={content}
          title={i18n.t('AVAILABLE_DATES')}
          trigger="click"
          visible={visible}
          onVisibleChange={handleVisibleChange}
        >
          <Row justify="end" style={{ width: '100%', cursor: 'pointer' }}>
            <span style={{ color: colors.blue }}>{i18n.t('VIEW_DATES')}</span>
          </Row>
        </Popover>
        <Col>
          <Typography.Text
            className="meal-details-title"
            ellipsis
            style={{ width: 257.5 }}
          >
            {meal.title}
          </Typography.Text>
        </Col>
        <Col>
          <div className="meal-details-description">{meal.description}</div>
        </Col>
      </div>
      <Row justify="center">
        <DesktopOrderButton onClick={handleButtonClick} />
      </Row>
    </Col>
  );
};

export const DesktopMealCarouselSelection: React.FC = () => {
  const dispatch = useDispatch();
  const { user, dataFilter } = useSelector(getUserState);
  const { meals } = useSelector(getMealState);
  const { advertisement } = useSelector(getAdminState);
  const mealsSorted = useSelector(sortedMealsByDistance);
  const filterData = getFilterData(mealsSorted, dataFilter);
  const history: History = useHistory();
  // const Breakfast = [
  //   `${moment('07:00', 'HH:mm').format('HH:mm')}`,
  //   `${moment('11:00', 'HH:mm').format('HH:mm')}`,
  // ];
  // const Lunch = [
  //   `${moment('11:00', 'HH:mm').format('HH:mm')}`,
  //   `${moment('17:00', 'HH:mm').format('HH:mm')}`,
  // ];
  const Dinner = [
    `${moment('17:00', 'HH:mm').format('HH:mm')}`,
    `${moment('23:00', 'HH:mm').format('HH:mm')}`,
  ];
  const currentTime = moment().format('HH:mm');
  const isEndTime = currentTime > Dinner[1];
  const filterM = _.filter(
    filterData.length > 0 || dataFilter.isFilter ? filterData : mealsSorted,
    item => {
      let hasMeal = false;
      item.schedule.filter((sched: any, i: number) => {
        if (
          item.cook !== user.userid &&
          moment(sched.date.seconds * 1000).format('YYYY/MM/DD') ===
            moment().format('YYYY/MM/DD')
        ) {
          hasMeal = true;
        }
        return hasMeal;
      });
      if (
        item.cook !== user.userid &&
        item.stableoffer &&
        item.stableoffer.isChecked
      ) {
        hasMeal = true;
      }

      // item.stableoffer.time.filter
      return hasMeal;
    }
  );
  const [filter, setFilter] = useState<string>('Newest First');
  const [newmeals, setNewMeals] = useState(filterM);
  const [isloading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [mealsPerPage] = useState(28);
  const { t } = useTranslation();
  const Newest = _.orderBy(filterM, 'timeadded', 'desc');
  const Oldest = _.orderBy(filterM, 'timeadded', 'asc');

  const handleMenuClick = (e: { key: string }) => {
    if (e.key === '1') {
      setFilter('Newest First');
      setNewMeals(Newest);
      return;
    }
    setFilter('Oldest');
    setNewMeals(Oldest);
  };

  const handleFieldChange = (e: React.FormEvent<HTMLInputElement>) => {
    const matchText = e.currentTarget.value.toLocaleLowerCase();
    console.log(currentPage);
    if (matchText !== '' || matchText !== undefined) {
      setCurrentPage(1);
    }
    const matchOrder = filterM.filter(order =>
      order.title.toLocaleLowerCase().match(matchText)
    );
    const filterNewestMeals = _.orderBy(matchOrder, 'timeadded', 'desc');
    setNewMeals(filterNewestMeals);
  };

  const handlePageChange = (page: number, pageSize: number | undefined) => {
    console.log(page);
    setCurrentPage(page);
  };

  const handleRemoveFilter = () => {
    setLoading(true);
    const filterData = {
      isFilter: false,
      distance: 0,
      consumption: '',
      price: 0,
      category: [],
      restrictions: [],
      selectedDate: {
        from: '',
        to: '',
      },
      constantOffer: false,
    };
    setTimeout(() => {
      dispatch(setFilterData(filterData));
      setLoading(false);
      // window.location.reload();
    }, 2000);
  };

  useEffect(() => {
    if (meals) {
      const filterNewest = _.orderBy(
        isEndTime ? mealsSorted : filterM,
        'timeadded',
        'desc'
      );
      if (dataFilter.isFilter) {
        setNewMeals(filterM);
        return;
      }
      setNewMeals(filterNewest);
    }
  }, [meals, dataFilter]);

  const indexOfLastMeal = currentPage * mealsPerPage;
  const indexOfFirstMeal = indexOfLastMeal - mealsPerPage;
  const currentMeals = newmeals.slice(indexOfFirstMeal, indexOfLastMeal);

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1">
        <span>{t('Newest First')}</span>
      </Menu.Item>
      <Menu.Item key="2">
        <span>{t('Oldest')}</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={24}
      // xl={20}
      className="meal-carousel-container"
    >
      <Row justify="end" className="filter-container">
        <Col xs={24} sm={24} md={20} lg={20} xl={18}>
          <Search handleFieldChange={handleFieldChange} />
        </Col>
        <Col className="filter-button">
          <Button type="link" onClick={() => history.push('/dashboard/filter')}>
            <FaSlidersH size={18} />
          </Button>
        </Col>
        <Row className="filter-contents">
          <span>{t('Filter by')}:</span>
          <div style={{ cursor: 'pointer' }}>
            <Dropdown overlay={menu} trigger={['click']}>
              <Row className="filter-dropdown">
                <span>{t(filter)}</span> <MdArrowDropDown size={24} />
              </Row>
            </Dropdown>
          </div>
        </Row>
      </Row>
      {dataFilter.isFilter ? (
        isloading ? (
          <div>
            <Spin />
            <span>Removing filters...</span>
          </div>
        ) : (
          <Row justify="start" style={{ marginBottom: '10px' }}>
            <Button className="search-icon" onClick={handleRemoveFilter}>
              <GiCancel size={18} color="#27aae1" />
            </Button>

            <span
              style={{
                color: '#27aae1',
                fontSize: '15px',
                fontWeight: 'bold',
                marginTop: '2px',
              }}
            >
              {`${i18n.t('Offer')} are filtered click button x to remove!`}
            </span>
          </Row>
        )
      ) : null}
      {newmeals.length > 0 ? (
        <Row className="meal-grid-display">
          {currentMeals.map((item, i) => (
            <div key={i} style={{ marginBottom: '27px' }}>
              {i % 10 === 9 && advertisement && advertisement.length > 0 ? (
                <Carousel
                  autoplay
                  effect="fade"
                  style={{ width: '280px', height: '460px' }}
                  dots={false}
                >
                  {advertisement &&
                    advertisement
                      .filter(item => item.position === '10th')
                      .map((item, i) => (
                        <div
                          key={i}
                          onClick={() => window.open(item.siteUrl, '_blank')}
                        >
                          <img
                            src={item.image}
                            style={{
                              cursor: 'pointer',
                              width: '270px',
                              objectFit: 'contain',
                            }}
                          />
                        </div>
                      ))}
                </Carousel>
              ) : (
                <MealItems meal={item} />
              )}
            </div>
          ))}
        </Row>
      ) : (
        <Row justify="center">
          <div className="cannot-find-meals">
            <img src={MealSearchImage} alt="Meal Search" />
            <span>{t('Cannot find offers')}</span>
          </div>
        </Row>
      )}
      <Pagination
        current={currentPage}
        defaultCurrent={1}
        total={newmeals.length}
        onChange={handlePageChange}
        pageSize={mealsPerPage}
      />
    </Col>
  );
};
